<template>
  <v-container fluid>
    <v-card class="mt-7" flat>
      <v-card-title class="justify-center" style="word-break: break-word">{{
        panelTitle
      }}</v-card-title>
      <v-card-text>
        <ent-select
        :label="selectLabel"
        :config="singleSelectSettings"
        :choices="selectionChoices"
        v-model="selection"
      />
      <ent-date-picker v-model="pickDate"></ent-date-picker>
      
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script setup>
  import EntInput from "@/../../library/view/EntInput.vue";
  import EntSelect from "@/../../library/view/EntSelect.vue";
  import EntSwitch from "@/../../library/view/EntSwitch.vue";
  import EntDatePicker from "@/../../library/view/EntDatePicker.vue"
  import EntTextField from "@/../../library/view/EntTextField.vue";
  import check from "@/../../library/helper/propertyCheck";

  // Get the Vue functions
  import { ref, computed, onMounted, watch, getCurrentInstance } from "vue";
  import useVuexPathify from "@/../../library/compFunctions/useVuexPathify.js";

  // Services used
  import { loadTable } from "@/../../cortex/src/services/cortex.js";

  // Helper functions used
  import phraseProc from "@/../../library/helper/phrase.js";

  // Define the props for this component
  const props = defineProps({
    args: { type: Object, required: false },
  });

  // Define the emits for this block
  const emit = defineEmits(["input", "update:saveok"]);

  // Get the VM instance - needed for some of the plugins
  const vm = getCurrentInstance();
  const { sync } = useVuexPathify(vm.proxy);
  console.log(`******** VM = `, vm);

  // Get the user languages and phrases
  const userlang = sync("misc/language");
  const phrases = sync("misc/phraseMap");

  // Function to run the phrase mapper
  const getPhrase = (item) => {
    return phraseProc.mapPhrase(item, phrases, userlang);
  };

   // Define the Panel Title
   const panelTitle = computed(() => {
    return getPhrase(props.args?.panelTitle)
   })
  // On Mounted
  onMounted(async () => {
    console.log(`****** Clone Search Function`);
    let strainTemp = loadTable("set_strain");
    let roomTemp = loadTable("set_rooms");
    let [strainList, roomList] = await Promise.all([strainTemp, roomTemp]);
  });
</script>
